import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFormik from "@/common/components/form/InputFormik";
import { IMessagesTemplate } from "@/types/messages-template.type";
import { Modal } from "flowbite-react";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useCreateMessageTemplate } from "@/common/hooks";
import MetaTextareaFormik from "@/common/components/form/MetaTextareaFormik";

interface FormMessagesTemplateProps<T> {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: IMessagesTemplate) => void;
  initialData?: T;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required("O nome é obrigatório"),
  message: Yup.string().required("A mensagem é obrigatória"),
});

export function FormMessagesTemplate({
  isOpen,
  onClose,
  onSave,
  initialData,
}: FormMessagesTemplateProps<IMessagesTemplate>) {
  const { mutate: createMessageTemplate, isPending } = useCreateMessageTemplate();

  const handleSubmit = (values: IMessagesTemplate) => {
    if (initialData) {
      onSave(values); 
    } else {
      createMessageTemplate(values);
    }
    onClose();
  };

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header>
        {initialData ? "Editar Template" : "Novo Template"}
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: initialData?.name || "",
            message: initialData?.components?.[0]?.text || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <div className="p-6.5">
                <div className="mb-4.5">
                  <InputFormik label="Nome" name="name" type="text" />
                </div>

                <div className="mb-4.5">
                  <MetaTextareaFormik name="message" />
                </div>


                <ButtonWithLoader type="submit" isLoading={isPending}>Salvar</ButtonWithLoader>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
